/** 分行页眉/页脚：编辑区用纯文本，存储与旧版富文本 HTML 兼容 */

function escapeHtml (text) {
  return String(text ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

export function zoneLineContentToPlain (html) {
  const raw = String(html ?? '')
  if (!raw.trim()) return ''
  if (!/<[a-z][\s\S]*>/i.test(raw)) return raw
  return raw
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/p>\s*<p[^>]*>/gi, '\n')
    .replace(/<\/div>\s*<div[^>]*>/gi, '\n')
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .trim()
}

export function plainToZoneLineContent (text) {
  const t = String(text ?? '')
  if (!t.trim()) return ''
  if (/<[a-z][\s\S]*>/i.test(t)) return t
  return t
    .split('\n')
    .map((line) => `<p>${escapeHtml(line)}</p>`)
    .join('')
}

/** 渲染前保留空格与换行（避免 HTML 折叠连续空格） */
export function preserveZoneLineWhitespaceHtml (html) {
  const raw = String(html ?? '')
  if (!raw.trim()) return raw
  return raw.replace(/(<p[^>]*>)([\s\S]*?)(<\/p>)/gi, (_, open, body, close) => {
    const inner = String(body)
      .replace(/&nbsp;/gi, '\u00a0')
      .replace(/\t/g, '    ')
    return `${open}${inner}${close}`
  })
}

/** 去掉富文本内联字号/字体，使行级样式生效 */
export function stripZoneLineInlineTypography (html) {
  if (!html || typeof document === 'undefined') return html
  const wrap = document.createElement('div')
  wrap.innerHTML = String(html)
  wrap.querySelectorAll('[style]').forEach((el) => {
    el.style.removeProperty('font-size')
    el.style.removeProperty('font-family')
    el.style.removeProperty('font-weight')
    el.style.removeProperty('line-height')
    if (!el.getAttribute('style')?.trim()) el.removeAttribute('style')
  })
  wrap.querySelectorAll('font').forEach((el) => {
    const span = document.createElement('span')
    span.innerHTML = el.innerHTML
    el.replaceWith(span)
  })
  return wrap.innerHTML
}

export const PRINT_ZONE_LINE_CLASS = 'print-zone-line'
